<template>
  <div>
    <!-- NOT USED? -->
    <div class="accordion-container clearfix">
      <div class="title clearfix" v-on:click="onExpand">
        <wes-question-number v-bind:index="question.displayId"></wes-question-number>
        <p>{{ question.label }}</p>
      </div>
      <div class="icon">
        <v-icon v-if="true === question.isValid" color="#4caf50" v-on:click="onExpand">done</v-icon>
        <v-icon v-else-if="false === question.isValid" color="#f44336" v-on:click="onExpand">error</v-icon>
        <v-icon v-else color="primary">$vuetify.icons.expand</v-icon>
      </div>
    </div>
    <div class="accordion-content" v-bind:class="{ displayed: isExpanded, hidden: !isExpanded }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vuetify from "vuetify";

export default {
  name: "WesQuestionAccordion",
  props: {
    question: Object
  },
  methods: {
    onExpand: function (event) {
      this.$data.isExpanded = !this.$data.isExpanded;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
    }
  },
  data: function () {
    return {
      isExpanded: false,
      isHelpDisplayed: false
    };
  }
};
</script>

<style scoped>
.accordion-container {
  width: 100%;
  /*margin: 2px 0;*/
  border: 2px solid #13314f;
  min-height: 50px;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.accordion-container:hover {
  cursor: pointer;
}
.title {
  font-weight: bold;
  float: left;
  width: 90%;
  text-align: left;
  padding: 8px;
}
.title > p {
  margin: 0 0 0 5px;
  float: right;
  text-align: left;
  width: 96%;
  line-height: 32px;
  font-size: 16px;
}
.icon {
  float: right;
  width: 5%;
  margin: 11px 0;
}
.accordion-content {
  min-height: 50px;
}
.displayed {
  display: block;
}
.hidden {
  display: none;
}
</style>
